import { Component, OnInit,Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainService } from 'src/app/services/main.service';
import { ThermostatSourceStatusService } from 'src/app/services/thermostat-source-status.service';

@Component({
    selector: 'app-thermostat-source-priority',
    templateUrl: './thermostat-source-priority.component.html',
    styleUrls: ['./thermostat-source-priority.component.css'],
    standalone: false
})
export class ThermostatSourcePriorityComponent implements OnInit {

  @Input() thermostatFeatureSourcePriorities: any;

  thermostatId: any;

  constructor(public mainService: MainService,public activatedRoute: ActivatedRoute,private thermostatSourceStatusService: ThermostatSourceStatusService) {
  }

  ngOnInit(): void {

    this.thermostatId = this.activatedRoute.snapshot.paramMap.get('id');

    this.mainService.updateRealTimeDataForThermostats$.subscribe((data) => {
      const lastThermostat = data && data.length > 0 ? data[data.length - 1] : null;

      if (lastThermostat) {

        if(this.thermostatId === lastThermostat.thermostatId) {
          this.thermostatFeatureSourcePriorities.forEach((sourcePriority: any) => {
            if (sourcePriority.category === 'solartempSensor') {
              sourcePriority.availabilityStatus = lastThermostat.heatAvailabilities.solar == 'available'? 'Available' : 'Unavailable';
              sourcePriority.currentStatus = this.thermostatSourceStatusService.getSolarStatus(lastThermostat);
            }else if (sourcePriority.category === 'heatPump') {
              sourcePriority.availabilityStatus = lastThermostat.heatAvailabilities.heatPump == 'available'? 'Available' : 'Unavailable';
              sourcePriority.currentStatus = this.thermostatSourceStatusService.getHeatPumpStatus(lastThermostat);
            }else if (sourcePriority.category === 'gasHeater') {
              sourcePriority.availabilityStatus = lastThermostat.heatAvailabilities.gas == 'available'? 'Available' : 'Unavailable'; 
              sourcePriority.currentStatus = this.thermostatSourceStatusService.getGasStatus(lastThermostat);
            }
        });
      }
    }
  });
  }

  getHeatingSpeedIcon(heatingSpeed: any): string {
    if (heatingSpeed === 1) {
      return 'assets/img/heating_speed_1.svg';
    } else if (heatingSpeed === 2) {
      return 'assets/img/heating_speed_2.svg';
    } else if (heatingSpeed === 3) {
      return 'assets/img/heating_speed_3.svg';
    } else {
      return 'assets/img/heating_speed_1.svg';
    }
  }

    getEnergyEfficiencyIcon(energyEfficiency: any): string {
      if (energyEfficiency === 1) {
        return 'assets/img/energy_efficiency_1.svg';
      } else if (energyEfficiency === 2) {
        return 'assets/img/energy_efficiency_2.svg';
      } else if (energyEfficiency === 3) {
        return 'assets/img/energy_efficiency_3.svg';
      } else {
        return 'assets/img/energy_efficiency_1.svg';
      }
    }

    getAvailabilityIcon(availability: any): string {
      if (availability?.toLowerCase() === 'available') {
        return 'assets/img/correct.svg';
      } else {
        return 'assets/img/info.svg';
      }
    }

    getHeatSourceIcon(arg0: any) {
      if(arg0 === 'gasHeater'){
        return 'assets/img/gas_heater.svg';
      } else if(arg0 === 'solartempSensor'){
        return 'assets/img/solar.svg';
      } else if(arg0 === 'heatPump'){
        return 'assets/img/Thermostat_Heat_Pump.svg';
      } else {
        return 'assets/img/gas_heater.svg';
      }  
    
    }

}